// utils/maskDirective.js

export const maskDirective = {
    beforeMount(el, binding) {
      const maskFormat = binding.value;
      el.addEventListener('input', () => applyMask(el, maskFormat));
    },
    updated(el, binding) {
      const maskFormat = binding.value;
      el.addEventListener('input', () => applyMask(el, maskFormat));
    },
    beforeUnmount(el) {
      el.removeEventListener('input', applyMask);
    }
  };
  
  // Function to apply the mask based on the given mask format
  function applyMask(el, maskFormat) {
    const originalValue = el.value;
    let value = originalValue.replace(/\W/g, ''); // Remove all non-alphanumeric characters
  
    let maskedValue = '';
    let maskIndex = 0;
  
    // Iterate over the value and apply mask rules
    for (let i = 0; i < value.length; i++) {
      if (maskIndex >= maskFormat.length) break;
  
      if (maskFormat[maskIndex] === 'A') {
        if (/[a-zA-Z]/.test(value[i])) {
          maskedValue += value[i];
        } else {
          continue; // Skip non-letters
        }
      } else if (maskFormat[maskIndex] === 'X') {
        if (/\d/.test(value[i])) {
          maskedValue += value[i];
        } else {
          continue; // Skip non-digits
        }
      } else {
        maskedValue += maskFormat[maskIndex];
        i--; // Don't move the input cursor forward
      }
  
      maskIndex++;
    }
  
    // Handle backspace: Remove extra static characters if needed
    if (originalValue.length > maskedValue.length) {
      while (maskedValue.length < maskFormat.length && !/[XA]/.test(maskFormat[maskedValue.length])) {
        maskedValue += maskFormat[maskedValue.length];
      }
    }
  
    // Update the input value only if it has changed
    if (maskedValue !== originalValue) {
      el.value = maskedValue;  // Update the input value
      el.dispatchEvent(new Event('input')); // Trigger the input event
    }
  }
  